import React from 'react';
import { Button } from 'reactstrap';
import { history } from 'store';
import IntlMessages from 'util/IntlMessages';
import CardBox from 'components/CardBox';
import ContainerHeader from 'components/ContainerHeader';
import OrgSurveyCompareRadarChart from './Components/OrgSurveyCompareRadarChart';

export class Component extends React.Component {
    constructor() {
        super();
    }
    componentDidMount() {
        this.props.showOrgSurveyLoader();
        this.props.fetchOrgSurveysCompareRadarChartData();
    }
    onBackToCompare = () => {
        history.push('/app/org-survey-compare/default');
    };

    render() {
        const {
            orgSurveyCompareRadarChartData,
        } = this.props;
        return (
            <div className="animated slideInUpTiny animation-duration-3">
                <ContainerHeader title={<IntlMessages id="chart.radar" />}/>

                <div className="row">
                    <CardBox heading="Selected Surveys Radar Chart">
                        <OrgSurveyCompareRadarChart data={ orgSurveyCompareRadarChartData }/>
                    </CardBox>
                </div>
            </div>
        );
    }
}

export default Component;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Component.js